import React, { useRef, useState } from "react";
import { useMachine } from "@xstate/react";
import questionMachine from "../machine";
import ResponsesListUI from "../ResponsesListUI";
import { CorrectAnswer, IncorrectAnswer, FirstTryIncorrect } from "./ArticleAnswers";
import { useEffect } from "react";
import { resolveSend } from "xstate/lib/actions";


export default function QuestionUI({ quiz, Q, qIndex, visible, setIsAnswerState, goNextQuestion, responseId, showNextQuestion, answerState }) {
  const holderRef = useRef(null);
  const { question, paragraph, responses, answerDetail } = Q;
  const [machine, send] = useMachine(questionMachine);
  const [resp, setResp] = useState(null);

  const handleFirstTry = (response) => {
    setResp(response);
    send("FIRST_ANSWER", { correct: response.correct });
    setIsAnswerState(false);
    holderRef.current.focus();
  };

  const handleSecondTry = (response) => {
    setResp(response);
    send("SECOND_ANSWER", { correct: response.correct });
    setIsAnswerState(false);
  };

  const handleTryAgain = () => {
    setResp(null);
    send("SECOND_TRY");

    setIsAnswerState(true);
  };
  const close = () => {
    setResp(null);
    setIsAnswerState(true);
    send("RESTART");
    // goNextQuestion();
  };

  const handleAnotherQuestion = () => {
    setResp(null);
    setIsAnswerState(true);
    send("RESTART");
    goNextQuestion();
  };

  const handleHashResponse = (response) => {
    console.log("Resp==>", response);
    setResp(response);
    // send("FIRST_ANSWER", { correct: response.correct });
    // if (!response.correct) {
    //   send("SECOND_TRY");
    //   send("SECOND_ANSWER", { correct: response.correct });
    // }
    send("HASH_ANSWER", { correct: response.correct })
    setIsAnswerState(false);
  }

  useEffect(() => {
    if (responseId) {
      const [response] = responses.filter(r => r.id === responseId);
      handleHashResponse(response);
      handleFirstTry(response);
    }
  }, [responseId]);

  return (
    <div className={visible ? "QuestionUI Visible" : "QuestionUI"} data-quiz-id={quiz.id} ref={holderRef} aria-live="polite">
      {machine.value === "correct" && (
        <>
          <CorrectAnswer
            handleAnotherQuestion={handleAnotherQuestion}
            showNextQuestion={showNextQuestion}
            close={close}
            answerDetail={answerDetail}
            quiz={quiz}
            article={quiz.articles[parseInt(qIndex)]}
          />
          <h3 tabIndex="-1" className="question" dangerouslySetInnerHTML={{ __html: question }} />
          <p tabIndex="-1" className="description" dangerouslySetInnerHTML={{ __html: paragraph }} />
          <ResponsesListUI
            quiz={quiz}
            question={Q}
            responses={responses}
            handleAnswerQuestion={handleSecondTry}
            hasOverlay={true}
            tabIndexNum={-1}
            selectedResponse={resp}
          />
        </>
      )}
      {machine.value === "incorrect" && (
        <>
          <IncorrectAnswer
            handleTryAgain={handleTryAgain}
            showNextQuestion={showNextQuestion}
            answerDetail={answerDetail}
            quiz={quiz}
            handleAnotherQuestion={handleAnotherQuestion}
            close={close}
            article={quiz.articles[parseInt(qIndex)]}
          />
          <h3 tabIndex="-1" className="question" dangerouslySetInnerHTML={{ __html: question }} />
          <p tabIndex="-1" className="description" dangerouslySetInnerHTML={{ __html: paragraph }} />
          <ResponsesListUI
            question={Q}
            quiz={quiz}
            responses={responses}
            handleAnswerQuestion={handleSecondTry}
            hasOverlay={true}
            tabIndexNum={-1}
            selectedResponse={resp}
          />
        </>

      )}
      {machine.value === "firsttryincorrect" && (
        <>
          <FirstTryIncorrect quiz={quiz} handleTryAgain={handleTryAgain} />
          <div className="content">
            <h3 tabIndex="-1" className="question" dangerouslySetInnerHTML={{ __html: question }} />
            <p tabIndex="-1" className="description" dangerouslySetInnerHTML={{ __html: paragraph }} />
            <ResponsesListUI
              question={Q}
              quiz={quiz}
              responses={responses}
              handleAnswerQuestion={handleSecondTry}
              hasOverlay={true}
              tabIndexNum={-1}
              selectedResponse={resp}
            />
          </div>
        </>
      )}
      {machine.value === "idle" && (
        <>
          <h3 tabIndex="0" className="question" dangerouslySetInnerHTML={{ __html: question }} />
          <p tabIndex="0" className="description" dangerouslySetInnerHTML={{ __html: paragraph }} />
          <ResponsesListUI
            question={Q}
            quiz={quiz}
            responses={responses}
            handleAnswerQuestion={handleFirstTry}
            hasOverlay={false}
            tabIndexNum={0}
          />
        </>
      )}
      {machine.value === "secondtry" && (
        <>
          <h3 tabIndex="0" className="question" dangerouslySetInnerHTML={{ __html: question }} />
          <p tabIndex="0" className="description" dangerouslySetInnerHTML={{ __html: paragraph }} />
          <ResponsesListUI
            question={Q}
            quiz={quiz}
            responses={responses}
            handleAnswerQuestion={handleSecondTry}
            hasOverlay={false}
            tabIndexNum={0}
            selectedResponse={resp}
          />
        </>
      )}
    </div>
  );
}
